export default __webpack_public_path__ + "static/media/topUp.ab687483.svg";